import PageContainer from "../../../components/global/PageContainer"
import Title from "../../../components/global/Title"
import ResourceCard from "../../../components/library/ResourceCard"
import { Grid } from "@mui/material"
import { useMemo } from "react"
import File from "../../../models/file"
import FadeFromTop from "../../../components/animations/FadeFromTop"
import { useTranslation } from "react-i18next"

const EngagementKit = () => {
  const { t, i18n } = useTranslation()

  // array of files
  const files: File[] = useMemo(
    () => [
      {
        uri:
          i18n.language === "it"
            ? "https://drive.google.com/file/d/1iL1LMBPvXMAeqWw7u_LfrbJJvSRC4ZkP"
            : "https://drive.google.com/file/d/16EesU8Bw8jkcMqXQ3A_Fwx62xuyn5Hb5",
        title: t("engagement_kit_description"),
      },
    ],
    [t]
  )

  return (
    <PageContainer
      title={t("engagement_kit")}
      breadcrumbs={[
        { title: t("operational_kit"), path: "/library" },
        { title: t("engagement_kit") },
      ]}
      withFilters={false}
      withDatePicker={false}
      withExportButton={false}
      paddingTop={24}
    >
      <Title fontSize={14}>{t("engagement_kit_description")}</Title>
      <Grid container spacing={3} columns={3} style={{ marginTop: 16 }}>
        {files.map((file, index) => (
          <Grid item xs={3} md={1} key={index}>
            <FadeFromTop delay={0.025 * index} style={{ height: "100%" }}>
              <ResourceCard file={file} />
            </FadeFromTop>
          </Grid>
        ))}
      </Grid>
    </PageContainer>
  )
}

export default EngagementKit
